﻿export default class ActionRightsControl {
    constructor(options) {
        this.dataItem = options.dataItem;
        this.localization = options.localization;
        this.actionLocalization = options.actionLocalization;
        this.fieldsTreeItem = options.fieldsTreeItem;
        this.fieldsFilterItem = options.fieldsFilterItem;
        this._initControl();
    }

    getData() {
        let treeData = $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.data().toJSON();
        this._serializeTree(treeData);
        return treeData;
    }

    _initControl() {
        this._initTree();
        this._initEvents();
    }

    _initTree() {
        let actionsRightsUrl = rootUrl + 'Role/GetRoleEntityAction?idRole=' + this.dataItem.IdRole + '&idEntity=' + this.dataItem.IdEntity;
        $.ajax({
            type: "GET",
            url: actionsRightsUrl,
            async: true,
            contentType: "application/json; charset=utf-8",
            success: (actions) => {
                this._replaceTypeNames(actions);
                this._normalizeTree(actions);
                this._constructTree(actions);
            },
            error: (e) => {
                toastr.error(this._getResource('GetActionsRightsError'));
            }
        });
    }

    _initEvents() {
        $('#' + this.fieldsFilterItem).on('input', (evt) => {
            this._filterTree();
        });
    }

    _filterTree() {
        let searchFilter = {
            field: "Name",
            operator: "contains",
            value: $('#' + this.fieldsFilterItem).val()
        };

        $('#' + this.fieldsTreeItem).data("kendoTreeView").dataSource.filter(searchFilter);
        $('.tree-parent-action').closest('.k-in').siblings('.k-checkbox-wrapper').hide();
    }

    _normalizeTree(actions) {
        actions.forEach(action => {
            if (action.Checked == null) {
                action.CanBeChecked = false;
            }

            if (action.Actions != null) {
                let items = action.Actions;

                items.forEach(item => {
                    item.CanBeChecked = true;
                    item.Name = this._normalizeActionName(item.Action);
                    item.IdRole = this.dataItem.IdRole;
                    item.checked = item.Checked;
                });

                action.Items = items;
            } else if(action.Items != null){
                this._normalizeTree(action.Items);
            }
        });
    }

    _serializeTree(actions) {
        actions.forEach(action => {
            if (action.CanBeChecked != null) {
                delete action.CanBeChecked;
            }

            if (action.Actions != null) {
                for (var i = 0; i < action.Actions.length; i++) {
                    delete action.Actions[i].Name;
                    delete action.Actions[i].CanBeChecked;
                    action.Actions[i].Checked = action.Items[i].checked;
                    delete action.Actions[i].checked;
                }

                delete action.Items;
            } else if (action.Items != null) {
                this._serializeTree(action.Items);
            }
        });
    }

    _normalizeActionName(action) {
        switch (action.Type) {
            case 'STANDARD_GENERAL': return this._getActionResource('GeneralAction_' + action.SubType);
            case 'STANDARD_ELEMENT': return this._getActionResource('ElementAction_' + action.SubType);
            default: return action.Text;
        }
    }

    _constructTree(items) {
        let dataSource = new kendo.data.HierarchicalDataSource({
            data: items, schema: {
                model: {
                    id: "Id",
                    children: "Items"
                }
            }
        });

        $('#' + this.fieldsTreeItem).kendoTreeView({
            template: `<div><span class="field-display-text#= item.CanBeChecked ? " tree-leaf-action" : " tree-parent-action" #">#= item.Name #</span></div>`,
            checkboxes: {
                name: 'Checked'
            },
            loadOnDemand: false,
            dataSource: dataSource,
            dataTextField: "Name",
            dataValueField: "Id"
        });

        $('.tree-parent-action').closest('.k-in').siblings('.k-checkbox-wrapper').hide();
        $('#' + this.fieldsTreeItem).data('kendoTreeView').expand('.k-item');
    }

    _replaceTypeNames(items) {
        items.forEach(item => {
            item.Name = this._getResource('ParentTypeConstant_' + item.ParentType);
        });
    }

    _getResource(name) {
        if (this.localization[name] != null && this.localization[name].trim() != '') {
            return this.localization[name];
        }

        return name;
    }

    _getActionResource(name) {
        if (this.actionLocalization[name] != null && this.actionLocalization[name].trim() != '') {
            return this.actionLocalization[name];
        }

        return name;
    }
}